/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from 'react';
import { withRouter, Link, useHistory, useLocation } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown';

import { leadsPagesOptions } from 'constants/dropdownOptions';
import { useUserDetailsContext } from 'context/userDetailsContext';
import useDynamicHeight from 'components/UI/NavbarHeight/useDynamicHeight';
import GlobalTooltip from 'components/GlobalTooltip';
import { ReactComponent as CollapsedIcon } from 'assets/svg/CollapsedIcon.svg';
import { ReactComponent as ExpandedIcon } from 'assets/svg/ExpandedIcon.svg';

function withSidebar(WrappedComponent) {
  function SideBar({ match, ...rest }) {
    const location = useLocation();
    const [menu, setMenu] = useState('');
    const { checkSubPermission, subscriptionAccess } = useUserDetailsContext();

    const history = useHistory();
    const { dynamicHeight } = useDynamicHeight();
    const [isCollapsed, setIsCollapsed] = useState(document.body.classList.contains('sidebar-collapsed'));

    const handleMenuChange = (e) => {
      setMenu(e.value);
      if (e.value === '') {
        history.push(match.url?.replace(/\/$/, ''));
      }
      history.push(`${match.url?.replace(/\/$/, '')}/${e.value}`);
    };

    const leadOptionFiltered = useMemo(
      () =>
        leadsPagesOptions.filter((o) => {
          if (o.value === 'tasks') {
            return checkSubPermission('task_management');
          } else if (o.value === 'text-messages') {
            return checkSubPermission('texting');
          } else if (o.value === 'mails') {
            return checkSubPermission('email_service');
          } else return true;
        }),
      [subscriptionAccess]
    );

    useEffect(() => {
      let splitted = location?.pathname?.split('/');
      setMenu(splitted[3] ?? '');
      return () => document.body.classList.remove('sidebar-collapsed');
    }, [match]);

    return (
      <div className="container-fluid">
        <div className="row pt-1 justify-content-between">
          <div className="side-nav shadow-middle d-none d-md-block p-0">
            <div
              className="pointer sidebar-toggle-icon"
              onClick={() => {
                document.body.classList.toggle('sidebar-collapsed');
                setIsCollapsed(!isCollapsed);
              }}
            >
              {isCollapsed ? (
                <ExpandedIcon style={{ width: 20, height: 20, color: 'var(--black-400)' }} />
              ) : (
                <CollapsedIcon style={{ width: 20, height: 20, color: 'var(--black-400)' }} />
              )}
            </div>
            <div className="my-3 side-nav-inner">
              {leadOptionFiltered.map((v, i) => {
                return (
                  <GlobalTooltip key={i} tooltip={isCollapsed && v.label} showDelay={250} position="right">
                    <Link
                      onClick={() => setMenu(v.path)}
                      to={v.path ? `${match.url}/${v.path}` : match.url}
                      className={menu === v.path ? 'current-nav' : ''}
                    >
                      <i className={menu === v.path ? v.icon_active : v.icon} />
                      <span className="menu-label">{v.label}</span>
                    </Link>
                  </GlobalTooltip>
                );
              })}
            </div>
          </div>
          <Dropdown
            className="d-md-none mb-3"
            options={leadOptionFiltered}
            optionValue="path"
            value={menu}
            onChange={handleMenuChange}
            filter
          />
          <div className="case-dm mb-0" style={{ height: `calc(${dynamicHeight} - 18px)` }}>
            <WrappedComponent match={match} {...rest} />
          </div>
        </div>
      </div>
    );
  }

  return withRouter(SideBar);
}

export default withSidebar;
